import { useState, useCallback } from 'react';
import type { SavedProject } from '@doer/frontend-components/creativity-editor';

const STORAGE_KEY = 'creativity-editor-projects';

export const useProjectStorage = () => {
  const [projects, setProjects] = useState<SavedProject[]>(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  });

  // Guardar proyecto
  const saveProject = useCallback((project: SavedProject) => {
    setProjects(prev => {
      const updated = [...prev, project];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  // Actualizar proyecto existente
  const updateProject = useCallback((id: string, updates: Partial<SavedProject>) => {
    setProjects(prev => {
      const updated = prev.map(p => (p.id === id ? { ...p, ...updates } : p));
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  // Obtener proyecto por ID
  const getProject = useCallback(
    (id: string): SavedProject | null => {
      return projects.find(p => p.id === id) || null;
    },
    [projects]
  );

  // Eliminar proyecto
  const deleteProject = useCallback((id: string) => {
    setProjects(prev => {
      const updated = prev.filter(p => p.id !== id);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  return {
    projects,
    saveProject,
    updateProject,
    getProject,
    deleteProject
  };
};
